<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QWjKXf/tc-custom/9781466852570.jpg?1731183706706" alt="This image is the cover for the book Mine to Take, Nine Circles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mine to Take, Nine Circles
      </h1>
      <p class="bookDescription body article font2">
        <b>In this erotic romantic suspense series opener, a young woman becomes the pawn of a billionaire out to destroy her family.</b><br/><br/>First in the Nine Circles series, featuring billionaire friends bound together by power, secrets, need . . . and the love they will find and stop at nothing to keep . . .<br/><br/>Gabriel Woolf is unstoppable. A ruthless businessman, he has perfected the art of revenge. Ever since his mother’s death, Gabriel has harbored only one wish: To take down the man who ruined their lives. But all bets are off when he meets his father’s stepdaughter, Honor St. James. Beautiful and innocent, she is everything Gabriel never knew he wanted—and now there’s no turning back . . .<br/><br/>Honor wasn’t born yesterday. She knows that Gabriel is a wolf in sheep’s clothing, willing to cross any line to get what he wants . . . herself included. But Gabriel’s passion for Honor—in spite of her connection to the man he hates the most—cannot be denied . . . and the feeling is utterly mutual. Can Gabriel be trusted? The only thing she knows for sure is how he makes her feel. And she can’t keep herself from coming back to him, over and over again . . . in <i>Mine to Take.</i><br/><br/><b>“A scintillating, heart-pounding love story. A dark, sinfully sexy hero with a tortured past. I loved it!” —Opal Carew, <i>New York Times</i>–bestselling author</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jackie Ashenden
      </h2>
      
      <p class="authorDescription body article"><P>Jackie Ashenden lives in Auckland, New Zealand with her husband, the inimitable Dr. Jax, and their two kids and two cats. When she's not torturing alpha males and their stroppy heroines, she can be found drinking chocolate martinis, reading anything she can lay her hands on, posting random crap on her blog, or being forced to go mountain biking with her husband. <br>Jackie writes dark, sexy contemporary romance for St Martin's Press, including the New York Billionaires Club series of novellas.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Paperbacks
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05ed9196